import * as z from "zod/v4";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum VariantNameFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

const VariantNameFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.VARIANT_NAME,
  VariantNameFilterQuery,
  z.array(z.string()),
);
export const VariantNameFilterSchema: z.ZodType<VariantNameFilter> =
  VariantNameFilterSchema_;
export interface VariantNameFilter
  extends z.infer<typeof VariantNameFilterSchema_> {}
